import styled from 'styled-components'

export const Nav = styled.div`
    display: flex;
    height: 3rem;
    box-shadow: 0 2px 8px #bdbdbd;
    background-color: #F5F0F6;
    justify-content: space-around;
`

export const NavDiv = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
`

export const ProfileDiv = styled.div`
    margin-right: 10px
`
export const Img = styled.img`
    height: 35px;
    width: 35px;   
    margin-left: auto;
    margin-right: auto;   
`
export const AvatarImg = styled.img`
    height: 30px;
    width: 30px;   
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`

